<template>
  <div class="searchWrapper">
    <!-- <div class="left">
        <i class="iconfont icon-biaoji"></i>
    </div>-->
    <div class="right">
      {{$t('h5.DSX_title')}}
    </div>
    <div class="language">
      <van-dropdown-menu @change="setLanguage">
        <van-dropdown-item v-model="value1" :options="option1" @change="setLanguage" />
      </van-dropdown-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textDesc: null,
      value1: "en",
      option1: [
        {
          text: "zh",
          value: "zh"
        },
        {
          text: "en",
          value: "en"
        }
      ]
    };
  },
  inject: ["reload"],
  create() {},
  methods: {
    setLanguage() {
      console.log(this.value1);
      localStorage.setItem("lang", this.value1);
      this.$i18n.locale = this.value1;
      this.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.searchWrapper {
  position: fixed;
  top: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 0.1rem 0.1rem 0.1rem 0;
  background-color: #fff;
  z-index: 99;

  .language{
    position: absolute;
    right: 1.5rem;

    /deep/.van-dropdown-menu__bar{
        box-shadow:none
    }
  }

  .left {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;

    .icon-biaoji {
      font-size: 30px;
      color: yellow;
      padding: 0 0.5rem;
    }
  }

  .right {
    flex: 1;
    text-align: center;
    font-size: 18px;
    padding: 10px 0;
    font-weight: bold;

    input {
      box-sizing: border-box;
      padding-left: 40px;
    }
    .inputbox {
      border-radius: 20px;
      width: 100%;
      border: none;
      height: 1.7rem;
      background-color: #eee;
    }
  }
}
</style>